const actionTypes = {
  SET_ACTIVE_REVIEW: "SET_ACTIVE_REVIEW",
  LIST_REVIEWS: "LIST_REVIEWS",
  ADD_REVIEW: "ADD_REVIEW",
  LIST_SELFIES: "LIST_SELFIES",
  SET_ACTIVE_SELFIE: "SET_ACTIVE_SELFIE",
};
export default actionTypes;
